import { useEffect, useState } from "react";
import "./Toast.css";

export default function Toast({ message, duration = 3000 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;

    setVisible(true);

    const t = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => clearTimeout(t);
  }, [duration, message]);

  if (!message || !visible) return null;

  return (
    <div className="imalandia-toast">
      {message}
    </div>
  );
}
